module.exports = __webpack_public_path__ + "fonts/bpmn.08b5f281.eot";